import * as API from "../api"
import * as LOGIN_API from "../api/loginNew"
import { message } from "antd"
import Cookies from "js-cookie"
import store from "../redux/store"

export interface ContentTypeProps {
	createTime: number
	createrWork: string
	createrWorkid: string
	direction: string
	id: number
	isDel: number
	name: string
	updateTime: number
	updateWork: string
	updateWorkid: string
}
export async function getContentType(type: string, value?: string) {
	const idMapLocal = localStorage.getItem("contentTypeIdMap")
	const nameMapLocal = localStorage.getItem("contentTypeNameMap")
	const listLocal = localStorage.getItem("contentTypeList")
	const idMap = idMapLocal ? JSON.parse(idMapLocal) : {}
	const nameMap = nameMapLocal ? JSON.parse(nameMapLocal) : {}
	let list = listLocal ? JSON.parse(listLocal) : []

	if (
		JSON.stringify(idMap) === "{}" ||
		JSON.stringify(nameMap) === "{}" ||
		list.length === 0
	) {
		const { code, data } = await API.getContentType({})
		if (code === 0) {
			data.forEach((item: ContentTypeProps) => {
				nameMap[item.name] = item.id
				idMap[item.id] = item.name
			})
			list = data
			localStorage.setItem("contentTypeList", JSON.stringify(data))
			localStorage.setItem("contentTypeNameMap", JSON.stringify(nameMap))
			localStorage.setItem("contentTypeIdMap", JSON.stringify(idMap))
		} else {
			message.error("获取内容形式失败")
		}
	}
	if (type === "id" && value) return idMap[value]
	if (type === "name" && value) return nameMap[value]
	if (type === "list") return list
	if (type === "idMap") return idMap
	if (type === "nameMap") return nameMap
	return null
}

export function storePermission(permission: AuthProps[]) {
	const authAll = permission
	const authMap = {
		route: authAll.filter((item) => item.resourceType === 0), // 菜单
		controller: authAll.filter((item) => item.resourceType === 1), // 控制器
		function: authAll.filter((item) => item.resourceType === 2), // 方法
		appType: authAll.filter((item) => item.resourceType === 3), // app类型
		btn: authAll.filter((item) => item.resourceType === 4), // 按钮
		normal: authAll.filter((item) => item.resourceType === 5), // 普通
	}
	localStorage.setItem("authAll", JSON.stringify(authAll))
	localStorage.setItem("authMap", JSON.stringify(authMap))
	return {
		authAll,
		authMap,
	}
}
/**
 * 获取权限
 * @param type 权限类型
 */
export type AuthType =
	| "route"
	| "controller"
	| "function"
	| "appType"
	| "btn"
	| "normal"
export interface AuthProps {
	id: string
	nameCn: string
	weight: number
	icon: string
	resourceType: number
	resourceName: string
	resourceVal: string
	[propName: string]: any
}

export function getAuth(type?: AuthType) {
	return new Promise((resolve, reject) => {
		const authMap = localStorage.getItem("authMap")
		const authAll = localStorage.getItem("authAll")
		if (authMap && authAll) {
			resolve(type ? JSON.parse(authMap)[type] : JSON.parse(authAll))
		} else {
			const token = Cookies.get("access_token")
			if (!token) {
				reject("no token")
				return
			}
			const userId = store.getState().baseInfo.userInfo.userid
			if (!userId) return
			LOGIN_API.getRoleInfoNew({ userId, accessToken: token })
				.then((res) => {
					const {
						result: { menuEntityList },
					} = res
					if (!menuEntityList) {
						resolve([])
						return
					}
					const permission = menuEntityList.map(
						({ menuValue, menuName, menuType, ...rest }) => ({
							resourceVal: menuValue,
							nameCn: menuName,
							resourceType: Number(menuType),
							...rest,
						})
					)
					const { authMap, authAll } = storePermission(permission)
					resolve(type ? authMap[type] : authAll)
				})
				.catch((err) => {
					reject(err)
				})
			// API.getAuthority().then(res => { // 获取权限
			// 	const { code, data, msg } = res
			// 	if (code === 0) {
			// 		const { authMap, authAll } = storePermission(data)
			// 		resolve(type ? authMap[type] : authAll)
			// 	} else {
			// 		message.error(msg)
			// 		reject(msg)
			// 	}
			// }).catch(err => {
			// 	reject(err)
			// })
		}
	})
}

/**
 * 根据resourceVal获取到当前资源下的子资源
 * @param val resourceVal
 * @param type 权限类型 btn按钮 route菜单路由
 */
export function getChildAuth(
	val: string,
	type?: AuthType,
	fieldName = "resourceVal"
) {
	return new Promise<any[]>((resolve) => {
		getAuth()
			.then((authAll: any) => {
				const authMap = localStorage.getItem("authMap")
				if (authMap) {
					const map = JSON.parse(authMap)
					const currentAuthId = authAll.find(
						(item: AuthProps) => item[fieldName] === val
					)?.id
					if (currentAuthId) {
						const target = type ? map[type] : authAll
						resolve(
							target.filter(
								(item: AuthProps) => item.parentMenuId === currentAuthId
							)
						)
					} else {
						resolve([])
					}
				} else {
					resolve([])
					return
				}
			})
			.catch(() => {
				resolve([])
			})
	})
}

/**
 * 全局通用的选择项
 */
export const customOptionsMap = {
	bussinessLine: [
		// 业务线
		{ name: "民宿", val: "民宿" },
		{ name: "酒店", val: "酒店" },
		{ name: "聚合", val: "聚合" },
		{ name: "景区", val: "景区" },
		{ name: "旅游线路", val: "旅游线路" },
		{ name: "素材", val: "素材" },
	],
	source: [
		// 来源
		{ name: "自创", val: "自创" },
		{ name: "合作方", val: "合作方" },
		{ name: "采购", val: "采购" },
	],
	audioType: [
		// 音频格式
		{ name: "mp3", val: "mp3" },
		{ name: "wav", val: "wav" },
		{ name: "acc", val: "acc" },
		{ name: "amr", val: "amr" },
		{ name: "apc", val: "apc" },
		{ name: "ape", val: "ape" },
		{ name: "flac", val: "flac" },
	],
}
export async function getAllCity() {
	const cityListLocal = localStorage.getItem("cityList")
	const cityList = cityListLocal ? JSON.parse(cityListLocal) : []
	if (cityList.length > 0) {
		return cityList
	} else {
		const { code, data } = await API.getAllCity({})
		if (code === 0 && data) {
			localStorage.setItem("cityList", JSON.stringify(data))
			return data
		} else {
			return []
		}
	}
}
export async function getTcityHome() {
	const cityListLocal = localStorage.getItem("tcityHome")
	const cityList = cityListLocal ? JSON.parse(cityListLocal) : []
	if (cityList.length > 0) {
		return cityList
	} else {
		const { code, data } = await API.getTcityHome({})
		if (code === 0 && data) {
			localStorage.setItem("tcityHome", JSON.stringify(data))
			return data
		} else {
			return []
		}
	}
}
export const reviewState = {
	r0: "已通过",
	r4: "未通过",
	r1: "未审核", // (业务待审核)
	r3: "法务待审核",
	r5: "已撤回",
	v1: "制作失败",
	v2: "制作中",
}
export const newReviewState = {
	"1": "系统审核中",
	"2": "系统已通过",
	"3": "系统未通过",
	"6": "法务待审核",
	"7": "法务已通过",
	"8": "法务未通过",
	"11": "已撤回",
}
export const tradeState = {
	"0": "提交",
	"1": "修改",
	"2": "业务审核",
	"3": "法务审核",
	"4": "撤回",
	"5": "风控审核",
	"6": "品牌初审",
	"7": "品牌终审",
	"8": "品牌微信审核",
}
export const tradeReviewState = {
	r0: "审核通过",
	r1: "待审核",
	r4: "驳回",
	r5: "已撤销",
}
